import CoreContext from '@context/CoreContext';
import { Button } from '@mosanic/fields/Button/Buttons';
import { AdvancedLabel, ControlDialog } from '@mosanic/items';
import { useContext } from "react";
import { MediaEditor } from "../Media/Editor";


const BuilderMediaEditor = () => {
    const cContext = useContext(CoreContext);
    

    return (
        <ControlDialog
            state={cContext.mediaEditor != null} 
            close={() => cContext.setMediaEditor(null)} 
            size="lg" 
            fullWidth={true}
        > 
            <AdvancedLabel helpText="From here you can manage all your media assets.">
                Media Editor
            </AdvancedLabel>
           
            <MediaEditor/>
            
            <Button onClick={() => cContext.setMediaEditor(null)} size="small" >
                Close 
            </Button>
        </ControlDialog>
    );
};
export default BuilderMediaEditor;